import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as moment from 'moment';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '../../../../core/components/base/base.component';
import { FeedbackService } from '../../../../core/services/feedback.service';
import { PatientService } from '../../../../core/services/patient.service';
import { BillingService } from './../../../../core/services/billing.service';

@Component({
  selector: 'app-billing-alert-list',
  templateUrl: './billing-alert-list.component.html',
  styleUrls: ['./billing-alert-list.component.scss']
})
export class BillingAlertListComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() filterValue: string = '';
  filteredPatients: any[] = [];
  allPatients: any[] = [];

  constructor(
    private patientService: PatientService,
    private billingService: BillingService,
    private router: Router,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit() {
    this.billingService.billingAlerts$
      .pipe(takeUntil(this.destroy$))
      .subscribe((results: any) => {
        this.allPatients = results;
        this.applyFilter();
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['filterValue']) {
      this.applyFilter();
    }
  }

  applyFilter() {
    if (this.filterValue.trim() === '') {
      this.filteredPatients = this.groupAndSort(this.allPatients);
    } else {
      const filterTerms = this.filterValue.toLowerCase().split(' ');
      const filteredData = this.allPatients.filter(item => {

        const icdCodesMatch = item.Patient.icdCodes?.some((icdCode: any) =>
          filterTerms.every(term =>
            _.includes((icdCode.code || '').toLowerCase(), term) ||
            _.includes((icdCode.description || '').toLowerCase(), term)
          )
        );

        const patientMatch = filterTerms.every(term =>
          _.includes(item.Patient.name.toLowerCase(), term) ||
          _.includes(item.Patient.surname.toLowerCase(), term) ||
          _.includes(item.Patient.patientNumber?.toLowerCase(), term) ||
          _.includes(item.Patient.diagnosis?.toLowerCase(), term) ||
          _.includes(item.code?.toLowerCase(), term)
        );

        return icdCodesMatch || patientMatch;
      });
      this.filteredPatients = this.groupAndSort(filteredData);
    }
  }

  private groupAndSort(data: any[]): any[] {
    // Group items by formatted date
    const groupedByDate = _.groupBy(data, item => {
      return item.date ? moment(item.date).format('YYYY-MM-DD') : moment(item.createdAt).format('YYYY-MM-DD');
    });

    // Transform the grouped data into an array of objects
    const transformed = _.map(groupedByDate, (items, date) => {
      // Group items by patient ID
      const groupedByPatient = _.groupBy(items, 'Patient.id');

      // Transform the grouped patient data into an array of objects
      const patients = _.map(groupedByPatient, (patientItems) => {
        const patient = { ...patientItems[0].Patient };
        patient.codes = patientItems.map(item => item.code);
        patient.alertType = patientItems[0].alertType
        return patient;
      });

      return { date, patients };
    });

    // Sort the transformed data by date in descending order
    return _.orderBy(transformed, 'date', 'desc');
  }


  navigateToPatientFile(patientId: string) {
    this.patientService.getPatientById(patientId)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(result => {
        this.router.navigate(['/patients', {
          outlets: {
            patient: ['file', patientId],
          }
        }]);
      }, error => {
        console.error(error);
        this.showToastMessage('There was an error loading the patient file. Please try again.');
      });
  }
}
